/* One Star Tees (2026-10-31): product-card color dots (snippets/ost-card-swatches.liquid). A dot swaps the card's
   photo to that colour and points the card's links at that variant. One delegated listener covers cards appended
   later (infinite scroll, search, "You may also like").
   Instant switching like Sloth Hiking Club (owner: "laggy"): every dot's photo is preloaded - with the card photo's
   own `sizes`, so the browser picks the same srcset file - once its card scrolls into view (and again on hover /
   touch as a fallback). A click shows the new photo at once if it is ready, otherwise as soon as it has decoded,
   so the old photo never blanks out. */
(function () {
  function cardImg(card) { return card && card.querySelector('.card__media .media img'); }

  function preload(dot, img) {
    if (dot._ostPre || !dot.dataset.src) return dot._ostPre;
    var p = new Image();
    p.decoding = 'async';
    if (img && img.sizes) p.sizes = img.sizes;
    if (dot.dataset.srcset) p.srcset = dot.dataset.srcset;
    p.src = dot.dataset.src;
    dot._ostPre = p;
    return p;
  }

  function preloadCard(card) {
    if (!card || card._ostPre) return;
    card._ostPre = true;
    var img = cardImg(card);
    card.querySelectorAll('.ost-swatch:not(.is-active)').forEach(function (d) { preload(d, img); });
  }

  function show(card, img, dot) {
    if (!dot.classList.contains('is-active')) return; // another dot was clicked meanwhile
    img.removeAttribute('loading');
    img.srcset = dot.dataset.srcset;
    img.src = dot.dataset.src;
    img.alt = dot.dataset.alt || img.alt;
  }

  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.ost-swatch');
    if (!dot) return;
    var card = dot.closest('.card-wrapper');
    if (!card) return; // product-page colour swatches also carry .ost-swatch: leave them to Dawn's picker
    e.preventDefault();
    e.stopPropagation();
    dot.parentNode.querySelectorAll('.ost-swatch').forEach(function (d) {
      var on = d === dot;
      d.classList.toggle('is-active', on);
      d.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    card.querySelectorAll('a.full-unstyled-link, a.card__link').forEach(function (a) { a.href = dot.dataset.url; });
    var img = cardImg(card);
    if (!img) return;
    var p = preload(dot, img);
    if (!p || (p.complete && p.naturalWidth)) return show(card, img, dot);
    (p.decode ? p.decode() : Promise.reject()).then(function () { show(card, img, dot); }, function () { show(card, img, dot); });
  }, true);

  // fallback warm-up: pointing at / touching a card
  function warm(e) {
    var card = e.target.closest && e.target.closest('.card-wrapper');
    if (card && card.querySelector('.ost-swatch')) preloadCard(card);
  }
  document.addEventListener('mouseover', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });
  document.addEventListener('focusin', warm);

  // main warm-up: cards on screen, after the page has loaded
  var conn = navigator.connection;
  if (!('IntersectionObserver' in window) || (conn && conn.saveData)) return;
  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 200); };
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      idle(function () { preloadCard(en.target); }, { timeout: 1500 });
    });
  }, { rootMargin: '200px 0px' });
  function watch(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card._ostSeen || !card.querySelector('.ost-swatch')) return;
      card._ostSeen = true;
      io.observe(card);
    });
  }
  function start() {
    watch();
    // cards added later (filters, sort, recommendations)
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; watch(); }, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
